// extracted by mini-css-extract-plugin
export var chatHtmlText = "_lx-2";
export var chatLink = "_lx-0";
export var chatText = "_lx-1";